import * as React from "react";
import { useTranslation } from "hooks";
import { Button, Icon } from "components";
import styles from "./Controls.module.css";

interface ControlsProps {
  onReset: () => void;
  onClear: () => void;
  onClose: () => void;
}

const Controls: React.FC<ControlsProps> = ({ onReset, onClear, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.controls}>
      <Button
        variant="clear"
        colorScheme="danger"
        prefix={<Icon name="delete-outlined" />}
        onClick={onClear}
      >
        {t("streaming.clearAll")}
      </Button>
      <Button
        variant="clear"
        prefix={<Icon name="undo-outlined" />}
        onClick={onReset}
      >
        {t("streaming.resetDefault")}
      </Button>
      <Button type="submit" onClick={onClose}>
        {t("streaming.apply")}
      </Button>
    </div>
  );
};

export default Controls;
